import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@comandero/powersync";

const DEFAULT_FEED_LIMIT = 200;

export interface ActivityFeedOptions {
  limit?: number;
  /** Vista "actividad del turno": filtra por sesión de caja. */
  registerSessionId?: string;
  /** Filtra por sucursal activa. */
  branchId?: string;
}

/**
 * Feed de actividad local (bucket PowerSync `activity_recent`, ~90 días).
 * El SQLite de la cuenta solo contiene los buckets de sus organizaciones,
 * así que no hace falta re-filtrar por usuario/org.
 * Orden canónico: server_ts DESC (desempate por id UUIDv7).
 */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: ActivityFeedOptions = {}) {
  const filters = [];
  if (options.registerSessionId) {
    filters.push(eq(activity_recent.register_session_id, options.registerSessionId));
  }
  if (options.branchId) {
    filters.push(eq(activity_recent.branch_id, options.branchId));
  }
  const base = db.select().from(activity_recent);
  const withWhere = filters.length > 0 ? base.where(and(...filters)) : base;
  return withWhere
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Historial local de una entidad concreta (para el sheet "Historial" del
 * detalle). El historial profundo (más allá de la retención) se pide a la API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
